import {
  object,
  string,
  array,
  boolean,
  AnyObject,
  StringSchema,
  bool
} from 'yup';

export type ServicesType = {
  services: {
    label: string;
    value: string;
    enabled: boolean;
  }[];
};

export type ServicesTypeUpdate = {
  name: string;
  values: string[];
  license_key: string;
};

const serviceSchema = object({
  label: string().required(),
  value: string().required(),
  enabled: boolean().required()
});

export const servicesSchema = object({
  services: array(serviceSchema).required()
});

export const servicesInitialValues: ServicesType = {
  services: [
    {
      label: 'Gunsmithing',
      value: 'Gunsmithing',
      enabled: false
    },
    {
      label: 'Training',
      value: 'Training',
      enabled: false
    },
    {
      label: 'Range',
      value: 'Range',
      enabled: false
    },
    {
      label: 'Retail',
      value: 'Retail',
      enabled: false
    }
  ]
};

export const getServiceByName = (name: string) => {
  return servicesInitialValues.services.find((row) => row.value === name);
};
